const base = '/payments'

export const billsAndPayment = {
    outstandingBills: `${base}/patient/outstanding-bills`
}